import styled from "styled-components";
import { colors } from "constants/colors";

export const StyledCard = styled.div<{ $isCapture?: boolean }>`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 337px;
  background-color: ${colors.white};
  border-radius: 20px;
  /* iOS html-to-image에서 box-shadow가 깨져 캡처 시에만 drop-shadow 사용 */
  box-shadow: ${({ $isCapture }) =>
    $isCapture ? "none" : "0 8px 7px 0 rgba(0, 0, 0, 0.16)"};
  filter: ${({ $isCapture }) =>
    $isCapture ? "drop-shadow(0 8px 7px rgba(0, 0, 0, 0.16))" : "none"};
  padding: 32px 14px 16px;
`;

export const StyledFlagImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 62px;
  height: auto;
  aspect-ratio: 279 / 62;
  object-fit: contain;
`;

export const StyledPhotoBox = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  width: 100%;
  margin-bottom: 12px;
  padding: 8px 26px 0;
`;

export const StyledPhotoInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 200px;
  margin-top: 8px;
`;

export const StyledPhotoImg = styled.img`
  width: 100%;
  height: auto;
  aspect-ratio: 200 / 109;
  object-fit: cover;
  margin-bottom: 6px;
`;
